import React from "react";
import { useLaravelReactI18n } from "laravel-react-i18n";
import ChatBot from "@/Components/ChatBot/ChatBot.jsx";
import { Head } from "@inertiajs/react";
import Header from "@/Components/Header.jsx";
import Footer from "@/Components/Footer.jsx";
import Breadcrumbs from "@/Components/Breadcrumbs.jsx";
import DecorBlob from "@/Components/Decor/DecorBlob.jsx";
import DecorContainer from "@/Components/Decor/DecorContainer.jsx";
import NewsBlock from "@/Components/NewsBlock.jsx";

export default function CaseItem(pageProps) {
    const { t } = useLaravelReactI18n();
    const email = "info@vivanti.eu";
    const handleEmailClick = () => {
        window.location.href = `mailto:${email}`;
    };

    return (
        <>
            <ChatBot
                csrf_token={pageProps.csrf_token}
                user_id={pageProps.user_id}
                is_admin={pageProps.is_admin}
            ></ChatBot>

            <Head>
                <title>{pageProps.case.seo_title}</title>
                <meta name="title" content={pageProps.case.seo_title} />
                <meta name="description" content={pageProps.case.meta_description} />

                <meta property="og:title" content={pageProps.case.seo_title} />
                <meta
                    property="og:description"
                    content={pageProps.case.meta_description}
                />
                <meta
                    property="og:image"
                    content={require('@images/social-banners/main.jpg')}
                />
            </Head>

            <Header locale={pageProps.locale} menu={pageProps.menu}></Header>

            <div className="case container mb-80px ph:mb-100px">
                <div className="container__inner">
                    <Breadcrumbs breadcrumbs={pageProps.breadcrumbs} pageName={pageProps.case.name} />

                    <div className="case__content mt-80px">
                        <h1 className="case__title">{pageProps.case.name}</h1>
                        <div className="tags mt-24px">
                            <div className="tag">
                                <span>{pageProps.case.category}</span>
                            </div>
                        </div>

                        <div className="case__columns mt-48px">
                            <div className="case__columns-row">
                                <div className="case__challenge" dangerouslySetInnerHTML={{
                                    __html: pageProps.case.content_1
                                }}></div>

                                <div className="case__img" dangerouslySetInnerHTML={{
                                    __html: pageProps.case.content_2
                                }}></div>
                            </div>

                            <div className="case__columns-row case__columns-row--wide">
                                <p dangerouslySetInnerHTML={{
                                    __html: pageProps.case.content_3
                                }}></p>
                            </div>

                            <div className="case__columns-row case__columns-row--wide">
                                <p dangerouslySetInnerHTML={{
                                    __html: pageProps.case.content_4
                                }}></p>
                            </div>
                        </div>
                    </div>
                    {pageProps.case.news.length !== 0 && <div className="case__news mt-80px">
                        <h4>{t("site.infoNewsCase.newsTitle")}</h4>
                        {
                            pageProps.case.news.map((data) => {
                                return <NewsBlock key={data.id}
                                    slug={data.slug}
                                    imgURL={data.image}
                                    title={data.name}
                                    text={data.description}
                                    locale={pageProps.locale}
                                />
                            })
                        }
                    </div>
                    }
                </div>

                <DecorContainer zIndex={2}>
                    <DecorBlob
                        typeNum={1}
                        width={1191.12}
                        rotate={-167}
                        opacity={0.1}
                        x={1150}
                        y={663}
                        animDuration={0}
                    />
                    <DecorBlob
                        typeNum={4}
                        width={1252.19}
                        blur={80}
                        rotate={120.609}
                        opacity={0.9}
                        x={1127}
                        y={438}
                        animDuration={0}
                    />

                    <DecorBlob
                        typeNum={4}
                        width={1252.19}
                        blur={150}
                        rotate={68}
                        opacity={0.8}
                        x={-760}
                        y={838}
                        animDuration={0}
                    />
                </DecorContainer>

            </div>
            <Footer pageProps={pageProps}></Footer>
        </>
    );
}
